<template>
	<div class="global-search-container" @click="showInputModal">
		<input
			type="text"
			name="search"
			:placeholder="$t('homePage.searchPlaceholder')"
			autocomplete="off"
			v-model="keyWord"
			id="search-filed"
			@keyup.enter="triggerSearchIfInputIsEmpty()"
		>
		<img
			src="@/drc/assets/icons/search_big.svg"
			alt="Search"
			@click="triggerSearchIfInputIsEmpty()"
		>
	</div>
</template>

<script>
import {EventGlobalSearch} from "@/common/configurations/event-bus.js";
import {searchFilterMixin} from "@/drc/mixins/search-filter-mixin";

export default {
	name: "GlobalSearch",
	mixins: [searchFilterMixin],
	data() {
		return {
			keyWord: "",
			results: []
		}
	},
	methods: {
		triggerSearchIfInputIsEmpty() {
			let modal = document.querySelector('.global-search-input-modal-wrapper');
			if (modal !== null && this.$store.getters.getGlobalSearchResult('word').trim() === '') {
				this.$router.push(this.getBaseUrl());
			}
		},
		showInputModal() {
			EventGlobalSearch.$emit("show-modal");
		}
	},
	watch: {
		keyWord(newValue) {
			EventGlobalSearch.$emit('trigger-global-search', newValue);
		}
	}
}
</script>
